





















import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/next/NewsItem.vue';
import { fetchNewslist } from '@/api/api';
import { getNews, getBaseInfo } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  bannerImg: string = '';
  baseInfo: any = {};

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  async onLoad() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    getNews(this.page, '全部', '9851').then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    console.log(res.data);
    if (res.data.data.length === 0 || res.data.data[0].list.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data.data[0].list];
    }
    this.loading = false;
  }
}
